import React, {useEffect, useState} from 'react';
import { CustomPicker, SketchPicker, CompactPicker } from 'react-color';
import {Fetch} from '../../utils';

const { feline_fetch } = Fetch;

const PaletteBox = ({ palette,last_palette_signature,set_last_palette_signature,last_palette_shuffle_index,set_last_palette_shuffle_index, apply_colour, selected_color, locally_selected_colour, set_locally_selected_colour }) => {
    try {
        const apply_palette = () => {
            var current_signature = JSON.stringify(palette.colors);
            var new_shuffle_index, new_colors;
            if(last_palette_signature == current_signature){
                new_shuffle_index = (last_palette_shuffle_index>=palette.colors.length-1)?0:last_palette_shuffle_index+1;
                new_colors = palette.colors.slice(new_shuffle_index,palette.colors.length).concat(palette.colors.slice(0, new_shuffle_index));
            }else{
                new_shuffle_index = 0;
                new_colors = palette.colors.slice(0,palette.colors.length);
            }
            window.design_editor.design.colorSwap(1,new_colors);window.design_editor.addUndoChange();
            set_last_palette_signature(current_signature);
            set_last_palette_shuffle_index(new_shuffle_index);
        }

        const select_colour = colour => {
        	apply_colour(colour);
        	set_locally_selected_colour(colour);
        }

        useEffect(() => {
        	set_locally_selected_colour(selected_color);
        }, [ selected_color ])

        return (
            <div style={{ width: 220, borderBottom: '1px solid rgb(238, 238, 238)', padding: '0px 0px 10px 10px' }}>
                <div style={{ textAlign: 'left', fontSize: 11, fontWeight: 500, color: '#888888', padding: 5, paddingLeft: 0 , cursor: 'pointer'}}>{palette.name=='default'?'':palette.name}</div>
                {palette.colors.map(color => (
                    <div onClick={() => select_colour(color)} style={{ cursor: 'pointer',display: "inline-block", width: 16, backgroundColor: color, height: 16, margin: '5px 10px 5px 0px', borderRadius: 3, boxShadow: locally_selected_colour == color ? color + ' 0px 0px 4px' : 'rgb(0 0 0 / 15%) 0px 0px 0px 1px inset'  }}></div>
                ))}
            </div>
        );
    } catch(err) {
        console.log('error in palette', err);
        return 'something went wrong';
    }
}


const dummy_data = [
    {
        "_id": "5f37c06d9b873b6444a46864",
        "name": "test ",
        "value": {
            "data": [
                "#ff00e2",
                "#0061ff",
                "#ff0083",
                "#83cc61",
                "#0072ff",
                "#00ff05",
                "#e000ff",
                "#000aff",
                "#0053ff",
                "#d5ff00",
                "#00ff77",
                "#d4ff00",
                "#ff00e2",
                "#ff00e2",
                "#0061ff",
                "#ff0083",
                "#83cc61",
                "#0072ff",
                "#00ff05",
                "#e000ff",
                "#000aff",
                "#0053ff",
                "#d5ff00",
                "#00ff77",
                "#d4ff00",
                "#ff00e2"
            ],
            "id": 0,
            "timestamp": "1597489244",
            "type": "hex"
        },
        "created_at": "2020-08-15T11:01:01.737Z",
        "updated_at": "2020-08-15T11:01:40.805Z"
    },
     {
        "_id": "5f37c06d9b873b6444a46864",
        "name": "twisted palette",
        "value": {
            "data": [
                "#ff00e2",
                "#0061ff",
                "#ff0083",
                "#83cc61",
                "#0072ff",
                "#00ff05",
                "#e000ff",
                "#000aff",
            ],
            "id": 0,
            "timestamp": "1597489244",
            "type": "hex"
        },
        "created_at": "2020-08-15T11:01:01.737Z",
        "updated_at": "2020-08-15T11:01:40.805Z"
    }
]

const Colour_Picker = props => {
    const [initialised,set_initialised] = useState(false);
	const [api_call_complete, set_api_call_complete] = useState(false);
	const [last_palette_signature,set_last_palette_signature] = useState("");
    const [last_palette_shuffle_index,set_last_palette_shuffle_index] = useState(0);
    const [color_palettes,set_color_palettes] = useState(0);
	const [ locally_selected_colour, set_locally_selected_colour ] = useState(null);

	const fetchBkFonts = async () => {
    	try{
    		set_initialised(true);
            console.log('color picker init --> ', props.user);
            // if(props.user){
			var resp = await feline_fetch({ url: 'user/get_brand_kit', method: 'GET' });
            if (!resp) {
                console.error("Empty response from server");
                return;
            }
			var brand_kit = JSON.parse(resp).data;
			if (brand_kit && brand_kit.length) {
				var colors = brand_kit.filter( x => x.name == 'colors' )[0].data.map( x => ({ name: x.name, colors: x.value.data }) );
                console.log('bk received -->', colors)
				set_color_palettes(colors);
				// }
            } else {
            	set_color_palettes([])
            	// set_color_palettes(dummy_data.map(x => ({ ...x, colors: x.value.data })))
            }
            set_api_call_complete(true);
        } catch(error) {
            return Promise.reject(error);
        }
    }

    useEffect(() => {
    	if (!initialised) {
    		fetchBkFonts();
    	}
    }, [])

    return (
    	<div style={{ height: color_palettes && color_palettes.length?386:"unset", overflowY: 'auto', background: 'rgb(255, 255, 255)', boxShadow: 'rgb(0 0 0 / 15%) 0px 0px 0px 1px, rgb(0 0 0 / 15%) 0px 8px 16px', borderRadius: 4, border: '0.5px solid grey' }}>
    		<SketchPicker { ...props } />
    		<div id="palette_box_picker" style={{ borderTop:'1px solid grey', background: 'rgb(255, 255, 255)', boxShadow: 'rgb(0 0 0 / 15%) 0px 0px 0px 1px, rgb(0 0 0 / 15%) 0px 8px 16px', borderRadius: '0px 0px 4px 4px' }}>
    			<div style ={{fontSize: 12, fontWeight: 550, color: 'black', textAlign: 'center', paddingTop: 5}}>Brand Kit Palettes</div>
                {(color_palettes && color_palettes.length) ? color_palettes.map((palette => (
                    <PaletteBox 
                    	palette={palette} 
                    	last_palette_signature={last_palette_signature} 
                    	set_last_palette_signature={set_last_palette_signature} 
                    	last_palette_shuffle_index={last_palette_shuffle_index} 
                    	set_last_palette_shuffle_index={set_last_palette_shuffle_index} 
                    	apply_colour={props.onChange}
                    	selected_color={props.color}
                    	locally_selected_colour={locally_selected_colour}
                    	set_locally_selected_colour={set_locally_selected_colour}
                    />
                ))) : (
                     <div style={{ textAlign:"center",cursor: 'pointer', fontSize: 11, fontWeight: 500, color: '#888888', padding: 5, paddingLeft: 0 }}>{api_call_complete ? "You have no color palettes" : "Loading brand kit color palettes"}</div>
                )}
            </div>
    	</div>
	);
}

export default CustomPicker(Colour_Picker);